// src/mixins/globalErrorHandlerMixin.js
import {errorReport} from '@/util/globalErrorHandler';

export const globalErrorHandlerMixin = {
  errorCaptured(err, vm, info) {
    // console.error('Global errorCaptured:', err);
    // console.error('Component causing error:', vm);
    // console.error('Error info:', info);

    errorReport(err, vm, info)

    // Return false to stop the error from propagating further
    return false;
  },

  methods: {
    safeExecute(fn, ...args) {
      try {
        return fn(...args);
      } catch (error) {
        errorReport(error);
      }
    }
  },
  // created() {
  //   // Wrap all lifecycle hooks
  //   // 'created',
  //   const lifecycleHooks = ['beforeCreate', 'beforeMount', 'mounted', 'beforeUpdate', 'updated', 'beforeDestroy', 'destroyed'];
  //   lifecycleHooks.forEach(hook => {
  //     if (this.$options[hook]) {
  //       const originalHook = this.$options[hook];
  //       this.$options[hook] = (...args) => {
  //         try {
  //           originalHook.apply(this, args);
  //         } catch (error) {
  //           handleQuotaExceededError(error);
  //         }
  //       }
  //     }
  //   });
  // }
};
